import script from "./contentsDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./contentsDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./contentsDetailPage.vue?vue&type=style&index=0&id=2aec273f&scoped=true&lang=css"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aec273f"]])

export default __exports__